import { memo } from 'react';
import { DialogContent, DialogActions, Button, Typography, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DialogForm, Form, FormSelectField, HandlerError, LoadingButton } from '@dfl/mui-react-common';
import { disabledActionTaken } from 'utils/flags-utils';
import { ActionTakenEnum } from '../../constants/action-taken.enum';

type Props = {
  open: boolean;
  onClose: () => void;
  control: any;
  onSubmit: () => void;
  isLoading: boolean;
  errors?: any;
  error?: any;
  title?: string;
};

const OrderConfirmComplete = ({ control, onSubmit, title, isLoading, open, errors, error, onClose }: Props) => {
  const { t } = useTranslation('order');

  return (
    <DialogForm
      open={open}
      maxWidth='sm'
      onClose={onClose}
      title={t(title ?? 'header.actions.complete')}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogContent>
        <Typography mb={2}>{t('header.actions.completeConfirm')}</Typography>

        <HandlerError error={error} errors={errors} />

        {!disabledActionTaken &&
          <Form
            id='completed-form'
            control={control}
            onSubmit={onSubmit}
            dark
          >
            <FormSelectField required size='small' fullWidth name='actionTaken' label={t('actionTaken.select')}>
              {Object.keys(ActionTakenEnum).map((option: string, index: number) => (
                <MenuItem key={index} value={option}>
                  {t(`actionTaken.${option}`)}
                </MenuItem>
              ))}
            </FormSelectField>
          </Form>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant='grey'>{t('common:cancel')}</Button>
        <LoadingButton type={disabledActionTaken ? 'button' : 'submit'} onClick={disabledActionTaken ? onSubmit : undefined} form='completed-form' autoFocus variant={'contained'} loading={isLoading}>
          {t('common:confirm')}
        </LoadingButton>
      </DialogActions>
    </DialogForm>
  );
};

export default memo(OrderConfirmComplete);
